











































import { computed, defineComponent, ref } from "@vue/composition-api";
import { Participant, ParticipantStatus } from "@scrile/api-provider/dist/api/ParticipantProvider";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import useAuthorisedOnly from "@/hooks/useAuthorisedOnly";
import providers from "@/lib/api";
import BaseButton from "@/components/BaseButton";
import BasePage from "@/components/BasePage";
import SiteLogo from "@/components/SiteLogo";
import RejectParticipation from "@/views/PageParticipantConsent/components/RejectParticipation.vue";

export default defineComponent({
  name: "PageParticipantConsentLink",
  components: { RejectParticipation, BaseButton, BasePage, SiteLogo },
  props: {
    urlUuid: { type: String, required: true },
    forceReject: { type: Boolean, default: false },
  },
  setup(props, { root }) {
    const loading = ref(true);
    const participant = ref<Participant | null>(null);
    const owner = ref<UserPublicData | null>(null);
    const showRejectModal = ref(false);

    const ownerName = computed(() => owner.value?.screenName ?? "");

    const getParticipant = async () => {
      const response = await providers.ParticipantProvider.search({ data: { urlUuid: props.urlUuid } });
      participant.value = response[0] ?? null;

      const available = participant.value?.status === ParticipantStatus.NEW && !!participant.value.postOwnerId;
      if (!available) {
        root.$router.replace({ name: "home" });
        return;
      }

      if (props.forceReject) {
        showRejectModal.value = true;
      }
    };

    const getOwner = async () => {
      if (!participant.value?.postOwnerId) return;

      const response = await providers.UserPublicDataProvider.search({
        data: { id: [participant.value.postOwnerId] },
      });
      owner.value = response.result[0] ?? null;
    };

    const getData = async () => {
      try {
        await getParticipant();
        await getOwner();
      } finally {
        loading.value = false;
      }
    };

    const openConsent = () => {
      root.$router.push({ name: "participantConsentLinkForm", params: { urlUuid: props.urlUuid } });
    };

    const openConsentAuthorised = useAuthorisedOnly(openConsent, {
      onLoginSuccess: openConsent,
      onSignUpSuccess: openConsent,
    });

    const onReject = async () => {
      if (!props.urlUuid || !participant.value) return;
      await providers.ParticipantProvider.reject({
        data: { urlUuid: props.urlUuid, id: participant.value.id },
      });
      showRejectModal.value = false;
      root.$router.replace({ name: "home" });
    };

    getData();

    return {
      loading,
      participant,
      ownerName,
      showRejectModal,
      openConsentAuthorised,
      onReject,
    };
  },
});
